import { $t } from '@/locales'
export default {
  // 月份
  monthList: {
    1: $t('一月'),
    2: $t('二月'),
    3: $t('三月'),
    4: $t('四月'),
    5: $t('五月'),
    6: $t('六月'),
    7: $t('七月'),
    8: $t('八月'),
    9: $t('九月'),
    10: $t('十月'),
    11: $t('十一月'),
    12: $t('十二月'),
  },

  // 账单明细表
  getTitle(Id) {
    // 快捷签
    const QUICKSIGN = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('签署人'),
        field: 'signTaskName',
      },
      {
        name: $t('签署ID'),
        field: 'signId',
      },
      {
        name: $t('文件hash'),
        field: 'signHash',
      },
      {
        name: $t('消费数量'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]

    // 合同
    const HETONG = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('签署任务名称'),
        field: 'signTaskName',
      },
      {
        name: $t('签署ID'),
        field: 'signId',
      },
      {
        name: $t('文件Hash'),
        field: 'signHash',
      },
      {
        name: $t('消费数量'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },

      // {
      //   name: '使用方',
      //   span: 2,
      //   field: 'initiatorName',
      // },
      // {
      //   name: '使用方主体',
      //   span: 2,
      //   field: 'initiatorSubjectName',
      // },
      // {
      //   name: '使用方部门',
      //   span: 2,
      //   field: 'initiatorDeptName',
      // },
    ]

    // 标准签
    const standardSign = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('签署任务名称'),

        field: 'signTaskName',
      },
      {
        name: $t('签署任务ID'),

        field: 'signId',
      },
      {
        name: $t('消费主体'),

        field: 'signUserName',
      },
      {
        name: $t('消费数量'),

        field: 'amount',
      },
      {
        name: $t('扣费方'),

        field: 'authGidedName',
      },
    ]

    // 实名认证
    const RN = [
      {
        name: $t('消费时间'),

        field: 'createTime',
      },
      {
        name: $t('平台名称'),

        field: 'appName',
      },
      {
        name: $t('子服务名称'),

        field: 'childProductName',
      },
      {
        name: $t('使用方'),

        field: 'identityName',
      },
      {
        name: $t('账号ID'),

        field: 'receiverAccountId',
      },
      {
        name: $t('消费金额'),

        field: 'amount',
      },
      {
        name: $t('业务ID'),

        field: 'bizId',
      },
      {
        name: $t('证件号'),

        field: 'idNo',
      },
      {
        name: $t('结果描述'),

        field: 'result',
      },
      {
        name: $t('扣费方'),

        field: 'authGidedName',
      },
    ]

    // 存证
    const CUNZHENG = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('子服务名称'),
        field: 'childProductName',
      },
      {
        name: $t('存证类型'),
        field: 'storeType',
      },
      {
        name: $t('存证份数'),

        field: 'consumeNum',
      },
      {
        name: $t('消费金额'),

        field: 'amount',
      },
      {
        name: $t('扣费方'),

        field: 'authGidedName',
      },
    ]

    const oldCUNZHENG = [
      {
        name: $t('消费时间'),

        field: 'createTime',
      },
      {
        name: $t('平台名称'),

        field: 'appName',
      },
      {
        name: $t('存证编号'),
        field: 'conserveId',
      },
      {
        name: $t('消费数量'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]

    const ZHENGSHU = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('子服务名称'),
        field: 'childProductName',
      },
      {
        name: $t('持有人名字'),
        field: 'name',
      },
      {
        name: $t('CA通道名称'),
        field: 'channelName',
      },
      {
        name: $t('消费金额'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]

    const CHUZHENG = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('出证申请人'),
        field: 'applicant',
      },
      {
        name: $t('出证编号'),
        field: 'taskNo',
      },
      {
        name: $t('消费金额'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]

    const IssueEviContextEntity = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('订单号'),
        field: 'no',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('出证类型'),
        field: 'typeDesc',
      },
      {
        name: $t('合同数'),
        field: 'pdfNum',
      },
      {
        name: $t('实际消费数'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]

    const AIComputeCostContextEntity = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('AI类型'),
        field: 'tradeTypeName',
      },
      {
        name: $t('AI编号'),
        field: 'tradeNo',
      },
      {
        name: $t('实际消费数'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]

    const CompanyAuthContextEntity = [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('实际消费数'),
        field: 'amount',
      },
      {
        name: $t('授权企业GID'),
        field: 'authGid',
      },
      {
        name: $t('被授权企业GID'),
        field: 'authedGid',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]
    const EshieldContextEntity = [
      {
        name: '消费时间',
        field: 'createTime',
      },
      {
        name: '消费量',
        field: 'amount',
      },
      {
        name: '消费次数',
        field: 'consumeNum',
      },
      {
        name: '子服务项名称',
        field: 'childProductName',
      },
      {
        name: '实际使用方',
        field: 'authGidedName',
      },

      {
        name: '行为id',
        field: 'actionId',
      },
      {
        name: '行为类型',
        field: 'actionType',
      },
      {
        name: '行为位置',
        field: 'actionLoc',
      },
      {
        name: '证书服务主体        ',
        field: 'certServiceOwner',
      },
      {
        name: '证书服务来源',
        field: 'certServiceLoc',
      },
    ]
    const billTypeTableDic = {
      '.QuickSignContextEntity': QUICKSIGN,
      '.SignContextEntity': HETONG,
      '.IdentityContextEntity': RN,
      '.ConserveContextEntity': oldCUNZHENG,
      '.StandardSignContextEntity': standardSign,
      '.EviStoreContextEntity': CUNZHENG,
      '.CertContextEntity': ZHENGSHU,
      '.CertificateContextEntity': CHUZHENG,
      '.IssueEviContextEntity': IssueEviContextEntity,
      '.AIComputeCostContextEntity': AIComputeCostContextEntity,
      '.CompanyAuthContextEntity': CompanyAuthContextEntity,
      '.EshieldContextEntity': EshieldContextEntity,
    }

    return billTypeTableDic[Id]
  },

  // 默认的账单明细表
  defalutTitle() {
    return [
      {
        name: $t('消费时间'),
        field: 'createTime',
      },
      {
        name: $t('平台名称'),
        field: 'appName',
      },
      {
        name: $t('使用情况'),
        field: 'amount',
      },
      {
        name: $t('扣费方'),
        field: 'authGidedName',
      },
    ]
  },

  // 默认地址
  getDefaultURL() {
    if (process.env.VUE_APP_MODE === 'test') {
      return {
        baseURL: 'http://testfront.tsign.cn:8880',
        dingURL: 'http://testdingsign.tsign.cn:8182',
        agentURL: 'http://172.16.8.88:13000/agentpage/agentmain.html',
        openUrl: 'http://172.20.61.234/',
        cunUrl: 'http://47.96.159.78:3415/public.html#/stores',
        billUrl: 'http://172.16.8.88:3388',
        userUrl: 'http://testfront.tsign.cn:8850/usercenter/personCenter/web',
        setPwdUrl: 'http://testfront.tsign.cn:8880/user/info',
      }
    } else if (process.env.VUE_APP_MODE === 'sml') {
      return {
        baseURL: 'https://smlfront.esign.cn:8880',
        dingURL: 'https://smldingsign.esign.cn',
        agentURL: 'http://172.16.8.88:13000/agentpage/agentmain.html',
        openUrl: 'http://smlopen.esign.cn/',
        cunUrl: 'https://smlfront.esign.cn:8840/public.html#/stores',
        billUrl: 'https://smlfront.esign.cn:8860',
        userUrl: 'https://smlfront.esign.cn:8850/usercenter/personCenter/web',
        setPwdUrl: 'https://smlfront.esign.cn:8880/user/info',
      }
    } else if (process.env.VUE_APP_MODE === 'prod') {
      return {
        dingURL: 'https://dingsign.esign.cn',
        baseURL: 'https://web.esign.cn',
        agentURL: 'https://www.esign.cn/agentpage/agentmain.html',
        openUrl: 'https://open.esign.cn/',
        cunUrl: 'https://evi.esign.cn/public.html',
        billUrl: 'https://order.esign.cn',
        userUrl: 'https://user.esign.cn/usercenter/personCenter/web',
        setPwdUrl: 'https://web.esign.cn/user/info',
      }
    }
  },

  // 银行
  getBank() {
    return [
      {
        value: 'CDB',
        text: $t('国家开发银行'),
      },
      {
        value: 'ICBC',
        text: $t('中国工商银行'),
      },
      {
        value: 'ABC',
        text: $t('中国农业银行'),
      },
      {
        value: 'BOC',
        text: $t('中国银行'),
      },
      {
        value: 'CCB',
        text: $t('中国建设银行'),
      },
      {
        value: 'PSBC',
        text: $t('中国邮政储蓄银行'),
      },
      {
        value: 'COMM',
        text: $t('交通银行'),
      },
      {
        value: 'CMB',
        text: $t('招商银行'),
      },
      {
        value: 'SPDB',
        text: $t('上海浦东发展银行'),
      },
      {
        value: 'CIB',
        text: $t('兴业银行'),
      },
      {
        value: 'HXBANK',
        text: $t('华夏银行'),
      },
      {
        value: 'GDB',
        text: $t('广东发展银行'),
      },
      {
        value: 'CMBC',
        text: $t('中国民生银行'),
      },
      {
        value: 'CITIC',
        text: $t('中信银行'),
      },
      {
        value: 'CEB',
        text: $t('中国光大银行'),
      },
      {
        value: 'EGBANK',
        text: $t('恒丰银行'),
      },
      {
        value: 'CZBANK',
        text: $t('浙商银行'),
      },
      {
        value: 'BOHAIB',
        text: $t('渤海银行'),
      },
      {
        value: 'SPABANK',
        text: $t('平安银行'),
      },
      {
        value: 'SHRCB',
        text: $t('上海农村商业银行'),
      },
      {
        value: 'YXCCB',
        text: $t('玉溪市商业银行'),
      },
      {
        value: 'YDRCB',
        text: $t('尧都农商行'),
      },
      {
        value: 'BJBANK',
        text: $t('北京银行'),
      },
      {
        value: 'SHBANK',
        text: $t('上海银行'),
      },
      {
        value: 'JSBANK',
        text: $t('江苏银行'),
      },
      {
        value: 'HZCB',
        text: $t('杭州银行'),
      },
      {
        value: 'NJCB',
        text: $t('南京银行'),
      },
      {
        value: 'NBBANK',
        text: $t('宁波银行'),
      },
      {
        value: 'HSBANK',
        text: $t('徽商银行'),
      },
      {
        value: 'CSCB',
        text: $t('长沙银行'),
      },
      {
        value: 'CDCB',
        text: $t('成都银行'),
      },
      {
        value: 'CQBANK',
        text: $t('重庆银行'),
      },
      {
        value: 'DLB',
        text: $t('大连银行'),
      },
      {
        value: 'NCB',
        text: $t('南昌银行'),
      },
      {
        value: 'FJHXBC',
        text: $t('福建海峡银行'),
      },
      {
        value: 'HKB',
        text: $t('汉口银行'),
      },
      {
        value: 'WZCB',
        text: $t('温州银行'),
      },
      {
        value: 'QDCCB',
        text: $t('青岛银行'),
      },
      {
        value: 'TZCB',
        text: $t('台州银行'),
      },
      {
        value: 'JXBANK',
        text: $t('嘉兴银行'),
      },
      {
        value: 'CSRCB',
        text: $t('常熟农村商业银行'),
      },
      {
        value: 'NHB',
        text: $t('南海农村信用联社'),
      },
      {
        value: 'CZRCB',
        text: $t('常州农村信用联社'),
      },
      {
        value: 'H3CB',
        text: $t('内蒙古银行'),
      },
      {
        value: 'SXCB',
        text: $t('绍兴银行'),
      },
      {
        value: 'SDEB',
        text: $t('顺德农商银行'),
      },
      {
        value: 'WJRCB',
        text: $t('吴江农商银行'),
      },
      {
        value: 'ZBCB',
        text: $t('齐商银行'),
      },
      {
        value: 'GYCB',
        text: $t('贵阳市商业银行'),
      },
      {
        value: 'ZYCBANK',
        text: $t('遵义市商业银行'),
      },
      {
        value: 'HZCCB',
        text: $t('湖州市商业银行'),
      },
      {
        value: 'DAQINGB',
        text: $t('龙江银行'),
      },
      {
        value: 'JINCHB',
        text: $t('晋城银行JCBANK'),
      },
      {
        value: 'ZJTLCB',
        text: $t('浙江泰隆商业银行'),
      },
      {
        value: 'GDRCC',
        text: $t('广东省农村信用社联合社'),
      },
      {
        value: 'DRCBCL',
        text: $t('东莞农村商业银行'),
      },
      {
        value: 'MTBANK',
        text: $t('浙江民泰商业银行'),
      },
      {
        value: 'GCB',
        text: $t('广州银行'),
      },
      {
        value: 'LYCB',
        text: $t('辽阳市商业银行'),
      },
      {
        value: 'JSRCU',
        text: $t('江苏省农村信用联合社'),
      },
      {
        value: 'LANGFB',
        text: $t('廊坊银行'),
      },
      {
        value: 'CZCB',
        text: $t('浙江稠州商业银行'),
      },
      {
        value: 'DYCB',
        text: $t('德阳商业银行'),
      },
      {
        value: 'JZBANK',
        text: $t('晋中市商业银行'),
      },
      {
        value: 'BOSZ',
        text: $t('苏州银行'),
      },
      {
        value: 'GLBANK',
        text: $t('桂林银行'),
      },
      {
        value: 'URMQCCB',
        text: $t('乌鲁木齐市商业银行'),
      },
      {
        value: 'CDRCB',
        text: $t('成都农商银行'),
      },
      {
        value: 'ZRCBANK',
        text: $t('张家港农村商业银行'),
      },
      {
        value: 'BOD',
        text: $t('东莞银行'),
      },
      {
        value: 'LSBANK',
        text: $t('莱商银行'),
      },
      {
        value: 'BJRCB',
        text: $t('北京农村商业银行'),
      },
      {
        value: 'TRCB',
        text: $t('天津农商银行'),
      },
      {
        value: 'SRBANK',
        text: $t('上饶银行'),
      },
      {
        value: 'FDB',
        text: $t('富滇银行'),
      },
      {
        value: 'CRCBANK',
        text: $t('重庆农村商业银行'),
      },
      {
        value: 'ASCB',
        text: $t('鞍山银行'),
      },
      {
        value: 'NXBANK',
        text: $t('宁夏银行'),
      },
      {
        value: 'BHB',
        text: $t('河北银行'),
      },
      {
        value: 'HRXJB',
        text: $t('华融湘江银行'),
      },
      {
        value: 'ZGCCB',
        text: $t('自贡市商业银行'),
      },
      {
        value: 'YNRCC',
        text: $t('云南省农村信用社'),
      },
      {
        value: 'JLBANK',
        text: $t('吉林银行'),
      },
      {
        value: 'DYCCB',
        text: $t('东营市商业银行'),
      },
      {
        value: 'KLB',
        text: $t('昆仑银行'),
      },
      {
        value: 'ORBANK',
        text: $t('鄂尔多斯银行'),
      },
      {
        value: 'XTB',
        text: $t('邢台银行'),
      },
      {
        value: 'JSB',
        text: $t('晋商银行'),
      },
      {
        value: 'TCCB',
        text: $t('天津银行'),
      },
      {
        value: 'BOYK',
        text: $t('营口银行'),
      },
      {
        value: 'JLRCU',
        text: $t('吉林农信'),
      },
      {
        value: 'SDRCU',
        text: $t('山东农信'),
      },
      {
        value: 'XABANK',
        text: $t('西安银行'),
      },
      {
        value: 'HBRCU',
        text: $t('河北省农村信用社'),
      },
      {
        value: 'NXRCU',
        text: $t('宁夏黄河农村商业银行'),
      },
      {
        value: 'GZRCU',
        text: $t('贵州省农村信用社'),
      },
      {
        value: 'FXCB',
        text: $t('阜新银行'),
      },
      {
        value: 'HBHSBANK',
        text: $t('湖北银行黄石分行'),
      },
      {
        value: 'ZJNX',
        text: $t('浙江省农村信用社联合社'),
      },
      {
        value: 'XXBANK',
        text: $t('新乡银行'),
      },
      {
        value: 'HBYCBANK',
        text: $t('湖北银行宜昌分行'),
      },
      {
        value: 'LSCCB',
        text: $t('乐山市商业银行'),
      },
      {
        value: 'TCRCB',
        text: $t('江苏太仓农村商业银行'),
      },
      {
        value: 'BZMD',
        text: $t('驻马店银行'),
      },
      {
        value: 'GZB',
        text: $t('赣州银行'),
      },
      {
        value: 'WRCB',
        text: $t('无锡农村商业银行'),
      },
      {
        value: 'BGB',
        text: $t('广西北部湾银行'),
      },
      {
        value: 'GRCB',
        text: $t('广州农商银行'),
      },
      {
        value: 'JRCB',
        text: $t('江苏江阴农村商业银行'),
      },
      {
        value: 'BOP',
        text: $t('平顶山银行'),
      },
      {
        value: 'TACCB',
        text: $t('泰安市商业银行'),
      },
      {
        value: 'CGNB',
        text: $t('南充市商业银行'),
      },
      {
        value: 'CCQTGB',
        text: $t('重庆三峡银行'),
      },
      {
        value: 'XLBANK',
        text: $t('中山小榄村镇银行'),
      },
      {
        value: 'HDBANK',
        text: $t('邯郸银行'),
      },
      {
        value: 'KORLABANK',
        text: $t('库尔勒市商业银行'),
      },
      {
        value: 'BOJZ',
        text: $t('锦州银行'),
      },
      {
        value: 'QLBANK',
        text: $t('齐鲁银行'),
      },
      {
        value: 'BOQH',
        text: $t('青海银行'),
      },
      {
        value: 'YQCCB',
        text: $t('阳泉银行'),
      },
      {
        value: 'SJBANK',
        text: $t('盛京银行'),
      },
      {
        value: 'FSCB',
        text: $t('抚顺银行'),
      },
      {
        value: 'ZZBANK',
        text: $t('郑州银行'),
      },
      {
        value: 'SRCB',
        text: $t('深圳农村商业银行'),
      },
      {
        value: 'BANKWF',
        text: $t('潍坊银行'),
      },
      {
        value: 'JJBANK',
        text: $t('九江银行'),
      },
      {
        value: 'JXRCU',
        text: $t('江西省农村信用'),
      },
      {
        value: 'HNRCU',
        text: $t('河南省农村信用'),
      },
      {
        value: 'GSRCU',
        text: $t('甘肃省农村信用'),
      },
      {
        value: 'SCRCU',
        text: $t('四川省农村信用'),
      },
      {
        value: 'GXRCU',
        text: $t('广西省农村信用'),
      },
      {
        value: 'SXRCCU',
        text: $t('陕西信合'),
      },
      {
        value: 'WHRCB',
        text: $t('武汉农村商业银行'),
      },
      {
        value: 'YBCCB',
        text: $t('宜宾市商业银行'),
      },
      {
        value: 'KSRB',
        text: $t('昆山农村商业银行'),
      },
      {
        value: 'SZSBK',
        text: $t('石嘴山银行'),
      },
      {
        value: 'HSBK',
        text: $t('衡水银行'),
      },
      {
        value: 'XYBANK',
        text: $t('信阳银行'),
      },
      {
        value: 'NBYZ',
        text: $t('鄞州银行'),
      },
      {
        value: 'ZJKCCB',
        text: $t('张家口市商业银行'),
      },
      {
        value: 'XCYH',
        text: $t('许昌银行'),
      },
      {
        value: 'JNBANK',
        text: $t('济宁银行'),
      },
      {
        value: 'CBKF',
        text: $t('开封市商业银行'),
      },
      {
        value: 'WHCCB',
        text: $t('威海市商业银行'),
      },
      {
        value: 'HBC',
        text: $t('湖北银行'),
      },
      {
        value: 'BOCD',
        text: $t('承德银行'),
      },
      {
        value: 'BODD',
        text: $t('丹东银行'),
      },
      {
        value: 'JHBANK',
        text: $t('金华银行'),
      },
      {
        value: 'BOCY',
        text: $t('朝阳银行'),
      },
      {
        value: 'LSBC',
        text: $t('临商银行'),
      },
      {
        value: 'BSB',
        text: $t('包商银行'),
      },
      {
        value: 'LZYH',
        text: $t('兰州银行'),
      },
      {
        value: 'BOZK',
        text: $t('周口银行'),
      },
      {
        value: 'DZBANK',
        text: $t('德州银行'),
      },
      {
        value: 'SCCB',
        text: $t('三门峡银行'),
      },
      {
        value: 'AYCB',
        text: $t('安阳银行'),
      },
      {
        value: 'ARCU',
        text: $t('安徽省农村信用社'),
      },
      {
        value: 'HURCB',
        text: $t('湖北省农村信用社'),
      },
      {
        value: 'HNRCC',
        text: $t('湖南省农村信用社'),
      },
      {
        value: 'NYNB',
        text: $t('广东南粤银行'),
      },
      {
        value: 'LYBANK',
        text: $t('洛阳银行'),
      },
      {
        value: 'NHQS',
        text: $t('农信银清算中心'),
      },
      {
        value: 'CBBQS',
        text: $t('城市商业银行资金清算中心'),
      },
    ]
  },
}
